import { CIcon } from '~/icons/types'
export const ciCheckSimple: CIcon = {
  name: 'check-simple',
  type: 'solid',
  width: 11,
  height: 11,
  paths: [
    {
      d:
        'M4.19625 9.38219L0.946245 6.13219C0.750991 5.93694 0.750991 5.62036 0.946245 5.42508L1.65333 4.71797C1.84859 4.5227 2.16519 4.5227 2.36044 4.71797L4.5498 6.90731L9.23916 2.21797C9.43441 2.02272 9.75101 2.02272 9.94627 2.21797L10.6534 2.92508C10.8486 3.12034 10.8486 3.43692 10.6534 3.63219L4.90335 9.38221C4.70808 9.57747 4.3915 9.57747 4.19625 9.38219Z',
      fill: 'currentColor'
    }
  ]
}
